export default __webpack_public_path__ + "static/media/mastercard.4836b1ec.svg";